<template>
  <section class="choose-channel">
    <img
      v-if="currentImage"
      class="choose-channel__image--bottom-margin"
      :src="currentImage"
      alt="channels-image"
    />

    <template v-if="loading">
      <HHeading> Carregando seus canais com {{ memberName }}... </HHeading>
    </template>
    <template v-else-if="channelsWithStaff.length">
      <HHeading>
        Escolha qual canal de {{ memberName }} deseja visualizar
      </HHeading>
      <ul
        v-for="channel in channelsWithStaff"
        :key="channel.id"
        class="choose-channel__list"
      >
        <li role="button" tabindex="0" @click="openChannel(channel)">
          {{ channel.name }}
        </li>
      </ul>
    </template>
    <template v-else>
      <HHeading class="choose-channel__heading--bottom-margin">
        Você não tem nenhum canal com {{ memberName }}
      </HHeading>
      <WButton v-if="enableCreateChannel" @click="showNewChannel">
        Criar canal
      </WButton>
    </template>
  </section>
</template>

<script>
import { WButton } from '@alice-health/wonderland-vue'
import { mapGetters, mapState } from 'vuex'

import { HHeading } from '@/components/shared/atoms'

export default {
  components: {
    HHeading,
    WButton
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters('pillars/channel', ['newChannel']),
    ...mapState('pillars/channel/member', ['channelsWithStaff']),
    ...mapState('user', ['user']),
    ...mapState('pillars/profile', ['liteProfile']),
    ...mapState('pillars', ['personId']),
    ...mapState('permissions', {
      channelsPermission: state => state.channels
    }),
    currentImage() {
      if (this.loading) {
        return require('@/assets/channels/channels-loading.gif')
      }

      return require('@/assets/conversation.svg')
    },
    memberName() {
      return this.liteProfile?.fullName
    },
    enableCreateChannel() {
      return this.channelsPermission?.general.create
    }
  },
  mounted() {
    this.loadChannels()
  },
  unmounted() {
    this.$store.dispatch('pillars/channel/member/clearChannelsByStaff')
  },
  methods: {
    openChannel(channel) {
      if (this.$route.query.channelId === channel.id) {
        return
      }
      this.$router.push(
        `/member/${channel.personId}/pillars?channelId=${channel.id}`
      )
    },
    handleChannels() {
      if (this.channelsWithStaff.length === 1) {
        this.openChannel(this.channelsWithStaff[0])
      }
    },
    showNewChannel() {
      this.$store.commit('pillars/channel/setControlChannel', this.newChannel)
      this.$store.commit('ui/channel/toggleChannelControl')
    },
    async loadChannels() {
      if (!this.user?.id) return

      await this.$store.dispatch(
        'pillars/channel/member/fetchChannelsByStaff',
        {
          memberId: this.personId
        }
      )

      setTimeout(() => {
        this.handleChannels()
        this.loading = false
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_non-rendering';
.choose-channel {
  padding: var(--gl-spacing-04);

  &__list {
    li {
      @extend %body-small;
      cursor: pointer;
      margin-top: var(--gl-spacing-06);

      &:hover {
        color: var(--gl-color-shades-magenta-60);
      }
    }
  }

  &__heading,
  &__image {
    &--bottom-margin {
      margin-bottom: var(--gl-spacing-04);
    }
  }
}
</style>
